import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index';
import Registration from '@/views/Registration.vue'
import RegularRegistration from '@/views/RegularRegistration.vue'
import Maintenance from '@/views/MaintenancePage.vue'
import SuccessPage from "@/views/SuccessPage";
import ForgotPassword from "@/views/ForgotPassword";
import ResetPassword from "@/views/ResetPassword";
import Login from "@/views/Login";
import {isGuest, isLoggedIn, ifAuthRedirect, redirectToProfile} from "@/boot/permission";
import Profile from "@/views/Profile";
import Dashboard from "@/views/profile/Dashboard";
import Analyzes from "@/views/profile/Analyzes";
import AnalyzesDetail from "@/views/profile/AnalyzesDetail";
import AnalyzesChart from "@/views/profile/AnalyzesChart";
import VisitsPast from "@/views/profile/VisitsPast";
import ConsultationsPast from "@/views/profile/ConsultationsPast";
import DiagnosticsPast from "@/views/profile/DiagnosticsPast";
import DiagnosticsPastFiles from "@/views/profile/DiagnosticsPastFiles";
import VisitsCurrent from "@/views/profile/VisitsCurrent";
import ConsultationsCurrent from "@/views/profile/ConsultationsCurrent";
import DiagnosticsCurrent from "@/views/profile/DiagnosticsCurrent";
import Info from "@/views/profile/Info";
import InfoChange from "@/views/profile/InfoChange";
import PasswordChange from "@/views/profile/PasswordChange";
import Clinics from "@/views/profile/Clinics";
import MobileInstall from "@/views/profile/MobileInstall";
import Balance from "@/views/profile/Balance";
import Order from "@/views/order/Order";
import OrderFindDoctor from "@/views/order/OrderFindDoctor";
import OrderChooseDoctor from "@/views/order/OrderChooseDoctor";
import OrderGuest from "@/views/order/OrderGuest";
import OrderChooseDoctorTimeTable from "@/views/order/OrderChooseDoctorTimeTable";
import OrderFindDiagnostic from "@/views/order/OrderFindDiagnostic";
import OrderChooseDiagnostic from "@/views/order/OrderChooseDiagnostic";
import OrderChooseDiagnosticTimeTable from "@/views/order/OrderChooseDiagnosticTimeTable";
import OrderFindLimit from '@/views/profile/OrderFindLimit'
import NotFoundPage from "@/views/NotFoundPage";
import ErrorPage from "@/views/ErrorPage.vue";
import OtherServicesCurrent from "@/views/profile/OtherServicesCurrent.vue";

Vue.use(VueRouter)
const routes = [
    {
        path: '/profile',
        component: Profile,
        beforeEnter: isLoggedIn,
        children: [
            {
                path: '',
                name: 'profile',
                component: Dashboard,
            },
            {
                path: 'mobile-install',
                name: 'mobile-install',
                component: MobileInstall,
            },
            {
                path: 'clinics',
                name: 'profile.clinics',
                component: Clinics,
            },
            {
                path: 'info',
                name: 'profile.info',
                component: Info,
                redirect: {
                    name: 'profile.info.info-change',
                },
                children: [
                    {
                        path: 'info-change',
                        name: 'profile.info.info-change',
                        component: InfoChange,
                    },
                    {
                        path: 'password-change',
                        name: 'profile.info.password-change',
                        component: PasswordChange,
                    },
                    {
                        path: 'balance',
                        name: 'profile.info.balance',
                        component: Balance,
                    },
                ],
            },
            {
                path: 'order',
                name: 'profile.order',
                component: Order,
                redirect: {
                    name: 'profile.order.find-doctor',
                },
                children: [
                    {
                        path: 'find-doctor',
                        name: 'profile.order.find-doctor',
                        component: OrderFindDoctor,
                        props: ({query: {specialization_id = null, clinic_id = null}}) => ({
                            specialization_id,
                            clinic_id,
                        }),
                    },
                    {
                        path: 'choose-doctor',
                        name: 'profile.order.choose-doctor',
                        component: OrderChooseDoctor,
                        props: ({query: {specialization_id, clinic_id = null}}) => ({
                            specialization_id,
                            clinic_id,
                        }),
                    },
                    {
                        path: 'choose-doctor-time-table',
                        name: 'profile.order.choose-doctor-time-table',
                        component: OrderChooseDoctorTimeTable,
                        props: ({query: {specialization_id, doctor_id, clinic_id = null, my_doctor = 0}}) => ({
                            specialization_id,
                            doctor_id,
                            clinic_id,
                            my_doctor
                        }),
                    },
                    {
                        path: 'find-diagnostic',
                        name: 'profile.order.find-diagnostic',
                        component: OrderFindDiagnostic,
                        // beforeEnter(to, from, next) {
                        //   if (store.state.auth.user.available_record_today > 0) {
                        //     next();
                        //   } else {
                        //     next({
                        //       name: 'profile.order.find-limit',
                        //     });
                        //   }
                        // },
                        props: ({query: {diagnostic_type_id = null, clinic_id = null}}) => ({
                            diagnostic_type_id,
                            clinic_id,
                        }),
                    },
                    {
                        path: 'choose-diagnostic',
                        name: 'profile.order.choose-diagnostic',
                        component: OrderChooseDiagnostic,
                        props: ({query: {diagnostic_type_id, clinic_id}}) => ({
                            diagnostic_type_id,
                            clinic_id,
                        }),
                    },
                    {
                        path: 'choose-diagnostic-time-table',
                        name: 'profile.order.choose-diagnostic-time-table',
                        component: OrderChooseDiagnosticTimeTable,
                        props: ({query: {diagnostic_id, diagnostic_type_id, clinic_id}}) => ({
                            diagnostic_id,
                            diagnostic_type_id,
                            clinic_id,
                        }),
                    },
                    {
                        path: 'find-limit',
                        name: 'profile.order.find-limit',
                        component: OrderFindLimit,
                    },
                ],
            },
            {
                path: 'visits-past',
                name: 'profile.visits.past',
                component: VisitsPast,
                redirect: {
                    name: 'profile.visits.past.consultations',
                },
                children: [
                    {
                        path: 'consultations',
                        name: 'profile.visits.past.consultations',
                        component: ConsultationsPast,
                    },

                ],
            },
            {
                path: 'diagnostics',
                name: 'profile.visits.past.diagnostics',
                component: DiagnosticsPast,
            },
            {
                path: 'diagnostics-files',
                name: 'profile.visits.past.diagnostics.files',
                component: DiagnosticsPastFiles,
            },
            {
                path: 'visits-current',
                name: 'profile.visits.current',
                component: VisitsCurrent,
                redirect: {
                    name: 'profile.visits.current.consultations',
                },
                children: [
                    {
                        path: 'consultations',
                        name: 'profile.visits.current.consultations',
                        component: ConsultationsCurrent,
                    },
                    {
                        path: 'diagnostics',
                        name: 'profile.visits.current.diagnostics',
                        component: DiagnosticsCurrent,
                    },
                    {
                        path: 'other_services',
                        name: 'profile.visits.current.other_services',
                        component: OtherServicesCurrent,
                    },
                ],
            },
            {
                path: 'analyzes',
                name: 'profile.analyzes',
                component: Analyzes,
            },
            {
                path: 'analyzes-detail',
                name: 'profile.analyzes.detail',
                component: AnalyzesDetail,
            },
            {
                path: 'analyzes-detail-chart',
                name: 'profile.analyzes.detail.chart',
                component: AnalyzesChart,
                props: ({query: {chart_id = null, marker_id = null}}) => ({
                    chart_id,
                    marker_id,
                }),
            },
        ],
    },

    {
        path: '/',
        name: 'home',
        redirect: {
            name: 'login',
        },
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        props: true,
        beforeEnter: isGuest,
        afterEnter:redirectToProfile
    },
    {
        path: '/registration',
        name: 'registration',
        beforeEnter:redirectToProfile,
        component: Registration,
    },
    {
        path: '/regular-register',
        name: 'registration.regular',
        component: RegularRegistration,
    },
    {
        path: '/success/:type',
        name: 'registration.success',
        component: SuccessPage,
        props: true
    },
    {
        path: '/error',
        name: 'error-page',
        component: ErrorPage,
        props: true
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        component: Maintenance
    },
    {
        path: '/forgot-password',
        name: 'password.forgot',
        component: ForgotPassword
    },
    {
        path: '/reset-password/:token',
        name: 'password.reset',
        component: ResetPassword,
        props: true
    },
    {
        path: '/404',
        name: 'not-found-page',
        component: NotFoundPage,
    },

    /** WORK PART OF SITE BUT NO NEED NOW **/
    // {
    //     path: '/order',
    //     name: 'order',
    //     component: Order,
    //     redirect: {
    //         name: 'order.find-doctor',
    //     },
    //     children: [
    //         {
    //             path: 'guest',
    //             name: 'order.guest',
    //             component: OrderGuest,
    //             beforeEnter: ifAuthRedirect('profile.order'),
    //             props: ({query: {type = null, service_id = null, time_table_id = null, doctor_id = null}}) => ({
    //                 type,
    //                 service_id,
    //                 time_table_id,
    //                 doctor_id,
    //             }),
    //         },
    //         {
    //             path: 'find-doctor',
    //             name: 'order.find-doctor',
    //             component: OrderFindDoctor,
    //             beforeEnter: ifAuthRedirect('profile.order.find-doctor'),
    //             props: ({query: {specialization_id = null, clinic_id = null, language = 'ru'}}) => ({
    //                 specialization_id,
    //                 clinic_id,
    //                 language,
    //                 guest: true,
    //             }),
    //         },
    //         {
    //             path: 'choose-doctor',
    //             name: 'order.choose-doctor',
    //             component: OrderChooseDoctor,
    //             beforeEnter: ifAuthRedirect('profile.order.choose-doctor'),
    //             props: ({query: {specialization_id, clinic_id = null}}) => ({
    //                 specialization_id,
    //                 clinic_id,
    //                 guest: true,
    //             }),
    //         },
    //         {
    //             path: 'choose-doctor-time-table',
    //             name: 'order.choose-doctor-time-table',
    //             component: OrderChooseDoctorTimeTable,
    //             beforeEnter: ifAuthRedirect('profile.order.choose-doctor-time-table'),
    //             props: ({query: {specialization_id, doctor_id, clinic_id = null}}) => ({
    //                 specialization_id,
    //                 doctor_id,
    //                 clinic_id,
    //                 guest: true,
    //             }),
    //         },
    //         {
    //             path: 'find-diagnostic',
    //             name: 'order.find-diagnostic',
    //             component: OrderFindDiagnostic,
    //             beforeEnter: ifAuthRedirect('profile.order.find-diagnostic'),
    //             props: ({query: {diagnostic_type_id = null, clinic_id = null}}) => ({
    //                 diagnostic_type_id,
    //                 clinic_id,
    //                 language,
    //                 guest: true,
    //             }),
    //         },
    //         {
    //             path: 'choose-diagnostic',
    //             name: 'order.choose-diagnostic',
    //             component: OrderChooseDiagnostic,
    //             beforeEnter: ifAuthRedirect('profile.order.choose-diagnostic'),
    //             props: ({query: {diagnostic_type_id, clinic_id = null}}) => ({
    //                 diagnostic_type_id,
    //                 clinic_id,
    //                 guest: true,
    //             }),
    //         },
    //         {
    //             path: 'choose-diagnostic-time-table',
    //             name: 'order.choose-diagnostic-time-table',
    //             component: OrderChooseDiagnosticTimeTable,
    //             beforeEnter: ifAuthRedirect('profile.order.choose-diagnostic-time-table'),
    //             props: ({query: {diagnostic_id, diagnostic_type_id, clinic_id = null}}) => ({
    //                 diagnostic_id,
    //                 diagnostic_type_id,
    //                 clinic_id,
    //                 guest: true,
    //             }),
    //         },
    //     ],
    // },


]

const router = new VueRouter({
    routes
})

router.beforeEach(async (to, from, next) => {
    if (!to.matched.length) {
        next({name: 'not-found-page'})
    } else {
        if (store.getters.maintenanceMode) {
            if (to.name === 'maintenance') {
                next()
            }
        } else {
            next()
        }
    }

    if (to.name.includes('choose-doctor-time-table') && +to.query.my_doctor === 1) {
        if (store.getters.personalDoctorId === null) {
            router.push({name:'profile'}).then()
        }
    }

})

export default router
